import { modalsConfig } from '../../../config';
import { MODAL_TYPES } from '../../../constants/types';

export default function usePropsConstructor() {
  // в modalsConfig лежат модалки и их хуки, которые можно создавать в админке
  const configHooks = Object.entries(modalsConfig).reduce((acc, [type, hook]) => {
    acc[type] = hook();
    return acc;
  }, {});

  return (modals) => {
    // проверяем, что модалки переданы (иногда может забаговаться и быть пустой массив)
    if (!modals.length) return null;

    const [{ system_name = MODAL_TYPES.slideModal }] = modals;

    // проверяем существование хука в configHooks и возвращаем null, если тип не найден (не создаем модалку)
    if (!configHooks[system_name]) {
      return null;
    }

    return {
      type: system_name,
      props: configHooks[system_name](modals),
    };
  };
}
